import React from "react";
import PageButton from "../../PageButton/PageButton";
import Score from "../../Score/Score";
import "./resultCard.scss";
import { ReactComponent as LocationIcon } from "assets/icons/location.svg";
import { Link } from "react-router-dom";

const Card = ({ data }) => {
  const shortDescription = data.description.slice(
    0,
    data.description.indexOf(". ") + 1
  );
  return (
    <div className="resultCard__container">
      <section className="resultCard__image__container">
        {/*<img*/}
        {/*  className="resultCard__image"*/}
        {/*  src={data.images.find((e) => e.cover).url}*/}
        {/*  alt={data.images.find((e) => e.cover).title}*/}
        {/*/>*/}
        <img
          className="resultCard__image"
          src='/car.webp'
          alt={'Generic Card Image'}

        />
      </section>

      <section className="resultCard__content">
        <div className="resultCard__profile">
          <section className="resultCard__headline">
            <h4 className="resultCard__stars">{data.category.title}</h4>
            <h2 className="resultCard__title">{data.title}</h2>
          </section>
          <Score tiny score={data.score} />
        </div>

        <section className="resultCard__location">
          <p>
            <LocationIcon /> {data.location.city}
          </p>
        </section>

        <article className="resultCard__description__container">
          <p className="resultCard__description">{shortDescription}</p>
          <Link key={data.id} to={`/product/${data.id}`}>
            <PageButton filled label="Ver más" />
          </Link>
        </article>
      </section>
    </div>
  );
};

export default Card;
